/* eslint-disable import/prefer-default-export */
export const addThousandSeparator = (n = '', separator = ' ') => (
  `${n}`
    .replace(' ', '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator)
);
